import { render, staticRenderFns } from "./Wp_img_swipe.vue?vue&type=template&id=f3ac064e&scoped=true&"
import script from "./Wp_img_swipe.vue?vue&type=script&lang=js&"
export * from "./Wp_img_swipe.vue?vue&type=script&lang=js&"
import style0 from "./Wp_img_swipe.vue?vue&type=style&index=0&id=f3ac064e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ac064e",
  null
  
)

export default component.exports